export class GenericEntity {
    id: number;
    uid: number;
    authorId: number;
    createdAt: string;
    updatedAt: string;
    version: number;
    isDeleted: boolean;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

